import { useState, useEffect } from 'react';
import {
  createCategories,
  deleteCategories,
  getCategoriesById,
  getCategoriess,
  updateCategories,
  updateActive
} from '../services/CategoriesService';
import useAlert from '../../../shared/hooks/useAlert';

export const useCategories = () => {

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { alert, showAlert } = useAlert();

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const response = await getCategoriess();
      setCategories(response.data);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch categories');
      showAlert('Error !!', 'danger');
    } finally {
      setLoading(false);
    }
  };

  const fetchCategoriesById = async (id) => {
    try {
      const response = await getCategoriesById(id);
      setCategories(categories.map(p => (p.id === id ? response.data : p)));
    } catch {
      setError('Failed to update categories');
      showAlert('Error !!', 'danger');
    }
  };

  const addCategories = async (product) => {
    try {
      const response = await createCategories(product);
      setCategories([...categories, response.data]);
      showAlert('Created successfully!', 'success');
    } catch {
      setError('Failed to add categories');
      showAlert('Error !!', 'danger');
    }
  };

  const editCategories = async (id, updatedCategories) => {
    try {
      const response = await updateCategories(id, updatedCategories);
      setCategories(categories.map(p => (p.id === id ? response.data : p)));
      showAlert('Updated successfully!', 'success');
    } catch {
      setError('Failed to update categories');
      showAlert('Error !!', 'danger');
    }
  };

  const updateOnActive = async (id, updatedStatus) => {
    try {
      const response = await updateActive(id, updatedStatus);
      setCategories(categories.map(p => (p.id === id ? response.data : p)));
      showAlert('Edited successfully!', 'success');
    } catch {
      setError('Failed to update categories');
      showAlert('Error creating', 'danger');
    }
  };


  const removeCategories = async (id) => {
    try {
      await deleteCategories(id);
      fetchCategories()
      setCategories(categories.filter(p => p.id !== id));
      showAlert('Remove successfully!', 'success');
    } catch {
      setError('Failed to delete categories');
      showAlert('Error !!', 'danger');
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return {
    categories,
    loading,
    error,
    alert,
    addCategories,
    editCategories,
    fetchCategoriesById,
    fetchCategories,
    removeCategories,
    updateOnActive
  };
}